export default "__VITE_PUBLIC_ASSET__8e64885c__"